import { render } from "./heading.vue?vue&type=template&id=a56551e8&scoped=true"
import script from "./heading.vue?vue&type=script&lang=js"
export * from "./heading.vue?vue&type=script&lang=js"

import "./heading.vue?vue&type=style&index=0&id=a56551e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a56551e8"]])

export default __exports__